export const isMobileDevice = (userAgent: string): boolean =>
  /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(userAgent);

export const isIPhoneDevice = (userAgent: string): boolean => /iphone|ipad|ipod|/i.test(userAgent);
